/////////////////////////////////////////////////////
// Social Sharing Buttons
/////////////////////////////////////////////////////

export function genericSocialShare(url) {
  window.open(url,'sharer','toolbar=0,status=0,width=648,height=395');
  return true;
}


// WEBPACK FOOTER //
// ./library/js/src/social-sharing.js